<div class="persona-switcher" *ngIf="personas.length > 0">
  <!-- Left Navigation Arrow -->
  <button
    class="nav-arrow nav-arrow-left"
    [disabled]="!canScrollLeft || disabled"
    (click)="onScrollLeft()"
    ngxTippy="Previous personas"
    [class.disabled]="!canScrollLeft || disabled"
    [ngClass]="{
      'tw-cursor-pointer': canScrollLeft && !disabled,
      'tw-cursor-not-allowed': !canScrollLeft || disabled
    }"
  >
    <i
      class="fas fa-chevron-left"
      [ngClass]="{
        'tw-cursor-pointer': canScrollLeft && !disabled,
        'tw-cursor-not-allowed': !canScrollLeft || disabled
      }"
    ></i>
  </button>

  <!-- Personas Container -->
  <div class="personas-container">
    <div class="personas-list" #personasList>
      <div
        *ngFor="let persona of getVisiblePersonas(); trackBy: trackByIndex"
        class="persona-item"
        [class.active]="persona.active"
        [ngxTippy]="tooltipTemplate"
        [tippyContext]="{ persona: persona }"
        [class.disabled]="disabled"
        (click)="onPersonaClick(persona.index)"
      >
        <div class="persona-content">
          <i class="fas" [ngClass]="persona.childCount !== undefined ? 'fa-users' : 'fa-user'"></i>
          <span class="persona-title">{{ persona.title }}</span>
          <span class="persona-count" *ngIf="persona.count !== undefined">({{ persona.count }})</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Navigation Arrow -->
  <button
    class="nav-arrow nav-arrow-right"
    [disabled]="!canScrollRight || disabled"
    (click)="onScrollRight()"
    ngxTippy="Next personas"
    [class.disabled]="!canScrollRight || disabled"
    [ngClass]="{
      'tw-cursor-pointer': canScrollRight && !disabled,
      'tw-cursor-not-allowed': !canScrollRight || disabled
    }"
  >
    <i
      class="fas fa-chevron-right"
      [ngClass]="{
        'tw-cursor-pointer': canScrollRight && !disabled,
        'tw-cursor-not-allowed': !canScrollRight || disabled
      }"
    ></i>
  </button>
</div>

<ng-template #tooltipTemplate let-persona="persona">
  <div>
    <p class="tw-font-regular tw-text-sm tw-text-center">{{ persona.title }}</p>
    @if(persona.childCount !== undefined) {
    <p class="tw-font-light tw-text-xs">Group count: {{ persona.count }}</p>
    <p class="tw-font-light tw-text-xs">Members count: {{ persona.childCount ?? 0 }}</p>
    }
  </div>
</ng-template>
